import { createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import {
  actionAccessRequest,
  addFeedback,
  deletePermanentlyFilesFolder,
  downloadFileFolderZIP,
  getAccessRequest,
  getAllReviewList,
  getHelpAndFeedback,
  getHomeFilesFolder,
  getLanguage,
  getLockedFileFolderList,
  getOpenFile,
  getOpenFilePublic,
  getOpenPublicFolder,
  getRecentFilesFolder,
  getSetting,
  getSharedFilesFolder,
  getStarredFileFolderList,
  getStaticPages,
  lockUnlockFileFolder,
  peopleSuggestion,
  requestShareFileAccess,
  restoreFilesFolder,
  searchFilesFolder,
  starUnstarFileFolder,
  suggestionsForMail,
  trashFilesFolder,
  uploadFolder,
  verifySecureFileFolder,
} from "store/services/general";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { openToast } from "store/slices/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";
import {
  setFolderUploadController,
  clearFolderUploadController,
} from "utils/uploadController";
import { setFolderUploadStatus } from "store/slices/general";

export const AddFeedbackAction = createAsyncThunk(
  "general/addFeedback",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, ...rest } = payload;
      const res = await addFeedback(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeCenterModal());
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetHomeFilesFolderAction = createAsyncThunk(
  "general/getHomeFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getHomeFilesFolder(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetRecentFilesFolderAction = createAsyncThunk(
  "general/getRecentFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getRecentFilesFolder(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetSharedFilesFolderAction = createAsyncThunk(
  "general/getSharedFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getSharedFilesFolder(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const SearchFilesFolderAction = createAsyncThunk(
  "general/searchFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await searchFilesFolder(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      // dispatch(
      //   openToast({
      //     type: "error",
      //     message: getApiMessage(response?.statusCode),
      //   }),
      // );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const RestoreFilesFolderAction = createAsyncThunk(
  "general/restoreFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const response = await restoreFilesFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const TrashFilesFolderAction = createAsyncThunk(
  "general/trashFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const response = await trashFilesFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        dispatch(closeCenterModal());
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const DeletePermanentlyFilesFolderAction = createAsyncThunk(
  "general/deletePermanentlyFilesFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const response = await deletePermanentlyFilesFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        dispatch(closeCenterModal());
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetHelpAndFeedbackAction = createAsyncThunk(
  "general/getHelpAndFeedback",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getHelpAndFeedback(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetSettingAction = createAsyncThunk(
  "general/getSetting",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getSetting();
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetSuggestionsMailAction = createAsyncThunk(
  "general/getSuggestions",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const res = await suggestionsForMail(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data.
        if (onSuccess) {
          onSuccess(res.response);
        }
        return fulfillWithValue(res);
      }

      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      // // handleAuthError(error?.response?.status);
      return rejectWithValue(error);
    }
  },
);

export const DownloadFileFolderZIPAction = createAsyncThunk(
  "general/downloadFileFolderZIP",
  async (payload, { rejectWithValue }) => {
    try {
      const { onSuccess, fileName, ...rest } = payload;

      const res = await downloadFileFolderZIP(rest);
      // get content type dynamically
      const contentType = res.headers["content-type"];

      // fallback name
      const fallbackName = `download-${dayjs().format("YYYY-MM-DD-HH-mm-ss")}`;

      const finalName =
        fileName ||
        (contentType === "application/zip"
          ? `${fallbackName}.zip`
          : fallbackName);

      // create blob with correct type
      const blob = new Blob([res.data], {
        type: contentType,
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", finalName);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      onSuccess?.();

      return true;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const StarUnstarFileFolderAction = createAsyncThunk(
  "general/starUnstarFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await starUnstarFileFolder(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data.
        if (onSuccess) {
          onSuccess?.();
        }
        return fulfillWithValue(res);
      }
      onError?.();
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetStarredFileFolderListAction = createAsyncThunk(
  "general/getStarredFileFolderList",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, ...rest } = payload;
    try {
      const res = await getStarredFileFolderList(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data.
        onSuccess?.();
        return fulfillWithValue(res);
      }

      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const LockUnlockFileFolderAction = createAsyncThunk(
  "general/lockUnlockFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await lockUnlockFileFolder(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data.
        dispatch(closeCenterModal());
        onSuccess?.();
        return fulfillWithValue(res);
      }
      onError?.();
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const VerifySecureFileFolderAction = createAsyncThunk(
  "general/verifySecureFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await verifySecureFileFolder(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data.
        onSuccess?.();
        return fulfillWithValue(res);
      }
      onError?.(getApiMessage(res?.statusCode));
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetLockedFileFolderListAction = createAsyncThunk(
  "general/getLockedFileFolderList",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, ...rest } = payload;
    try {
      const res = await getLockedFileFolderList(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data.
        onSuccess?.();
        return fulfillWithValue(res);
      }

      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetOpenFileAction = createAsyncThunk(
  "general/getOpenFile",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { type = "", onError, ...rest } = payload;
    try {
      const response = await getOpenFile(rest);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      if (type !== "sharelink") {
        dispatch(
          openToast({
            type: "error",
            message: getApiMessage(response?.statusCode),
          }),
        );
      }
      onError?.(response);
      return rejectWithValue(response);
    } catch (error) {
      onError?.();
      if (type !== "sharelink") {
        dispatch(
          openToast({
            type: "error",
            message: error?.response?.data?.statusCode
              ? getApiMessage(error?.response?.data?.statusCode)
              : error?.message,
          }),
        );
      }
      return rejectWithValue(error);
    }
  },
);

export const GetOpenFilePublicAction = createAsyncThunk(
  "general/getOpenFilePublic",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { type = "", onError, ...rest } = payload;
    try {
      const response = await getOpenFilePublic(rest);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      onError?.(response);
      if (type !== "sharelink") {
        dispatch(
          openToast({
            type: "error",
            message: getApiMessage(response?.statusCode),
          }),
        );
      }
      return rejectWithValue(response);
    } catch (error) {
      onError?.(error?.response?.data);
      if (type !== "sharelink") {
        dispatch(
          openToast({
            type: "error",
            message: error?.response?.data?.statusCode
              ? getApiMessage(error?.response?.data?.statusCode)
              : error?.message,
          }),
        );
      }
      return rejectWithValue(error);
    }
  },
);

export const GetLanguageAction = createAsyncThunk(
  "get/getLanguage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getLanguage();
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const PeopleSuggestionAction = createAsyncThunk(
  "get/peopleSuggestion",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await peopleSuggestion(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const RequestShareFileAccessAction = createAsyncThunk(
  "general/requestShareFileAccess",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await requestShareFileAccess(rest);
      if (res.status === 1) {
        onSuccess?.();
        return fulfillWithValue(res);
      }
      onError?.(res);
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      onError?.(error?.response?.data);
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetAccessRequestAction = createAsyncThunk(
  "general/getAccessRequest",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await getAccessRequest(rest);
      if (res.status === 1) {
        onSuccess?.();
        return fulfillWithValue(res);
      }
      onError?.();
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const ActionAccessRequestAction = createAsyncThunk(
  "general/actionAccessRequest",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await actionAccessRequest(rest);
      if (res.status === 1) {
        onSuccess?.();
        return fulfillWithValue(res);
      }
      onError?.();
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetOpenPublicFolderAction = createAsyncThunk(
  "general/getOpenPublicFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getOpenPublicFolder(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetAllReviewListAction = createAsyncThunk(
  "get/getAllReviewList",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getAllReviewList(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UploadFolderAction = createAsyncThunk(
  "general/uploadFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { zip, parentId, name, onSuccess, onError } = payload;

    // Create a new AbortController for this upload so it can be cancelled.
    const controller = new AbortController();
    setFolderUploadController(controller);

    try {
      const formData = new FormData();
      const fileName = name ? `${name}.zip` : "Uploaded_Folder.zip";
      formData.append("zip", zip, fileName);
      if (parentId) {
        formData.append("parentId", parentId);
      }

      const res = await uploadFolder(formData, controller.signal);

      clearFolderUploadController();

      if (res.status === 1) {
        dispatch(setFolderUploadStatus("uploaded"));
        if (onSuccess) onSuccess();
        return fulfillWithValue(res);
      }

      dispatch(setFolderUploadStatus("failed"));
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      if (onError) onError();
      return rejectWithValue({
        message: getApiMessage(res?.statusCode) || "Upload failed",
      });
    } catch (error) {
      clearFolderUploadController();

      // Check if the request was cancelled (aborted)
      const isCancelled =
        error?.code === "ERR_CANCELED" ||
        error?.name === "AbortError" ||
        error?.message === "canceled";

      dispatch(setFolderUploadStatus(isCancelled ? "canceled" : "failed"));

      if (!isCancelled) {
        if (onError) onError();
        dispatch(
          openToast({
            type: "error",
            message: error?.response?.data?.statusCode
              ? getApiMessage(error?.response?.data?.statusCode)
              : error?.message || "An error occurred",
          }),
        );
      } else {
        if (onError) onError();
      }

      return rejectWithValue(error);
    }
  },
);

export const GetStaticPagesAction = createAsyncThunk(
  "get/staticPages",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getStaticPages(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }

      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      // // handleAuthError(error?.response?.status);
      return rejectWithValue(error);
    }
  },
);
